import { Close16, Close20 } from "@carbon/icons-react";
import { StandardTable, Button, Modal, InputText } from "react3l-ui-library";
import { Col, Row, Spin } from "antd";
import { useMenuReportHistoryPreview } from "./MenuReportHistoryPreviewHook";
import { useTranslation } from "react-i18next";
import { MODAL_SIZE } from "react3l-ui-library/build/components/Modal/Modal";

function MenuReportHistoryPreview() {
  const {
    handleGoBack,
    handleCloseModal,
    listFileTemplate,
    fileTemplateInputColumns,
    fileTemplateInputsInternal,
    visible,
    columns: fileTemplateColumns,
    isSpinning,
    model,
  } = useMenuReportHistoryPreview();

  const [translate] = useTranslation();

  return (
    <Spin spinning={isSpinning}>
      <div className="page-content page-content-dxg" id={"page-content-dxg-id"}>
        <div className="info-component ml-4 mb-3">
          <span>{translate("menuReports.master.header")}</span>
          <span> &gt; </span>
          <span>{translate("menuReports.master.subHeader")}</span>
          <span> &gt; </span>
          <span>{translate("general.actions.listHistory")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("menuReports.viewPreview")}
          </span>
        </div>
        <div className="page page-detail p-t--lg p-l--md p-r--sm p-b--lg">
          <div className="mb-3 d-flex justify-content-between border-bottom">
            <h5 className="font-bold ml-3">
              {translate("menuReports.viewPreview")}
            </h5>
            <div className="pb-2">
              <Button
                type="secondary"
                className="btn--lg btn-red"
                icon={<Close16 />}
                onClick={handleGoBack}
              >
                {translate("general.actions.close")}
              </Button>
            </div>
          </div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <InputText
                label={translate("menuReports.site")}
                isRequired={true}
                type={0}
                value={model.site?.name}
                placeHolder={translate("menuReports.placeholder.site")}
                disabled
              />
            </Col>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <InputText
                label={translate("menuReports.menu")}
                isRequired={true}
                type={0}
                value={model.menu?.name}
                placeHolder={translate("menuReports.placeholder.menu")}
                disabled
              />
            </Col>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <InputText
                label={translate("menuReports.name")}
                isRequired={true}
                type={0}
                value={model.name}
                placeHolder={translate("menuReports.placeholder.name")}
                disabled
              />
            </Col>
          </Row>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="p-t--xxs"
          ></Row>
          <div className="page-history__list">
            <StandardTable
              rowKey={"id"}
              columns={fileTemplateColumns}
              dataSource={listFileTemplate}
              tableSize={"md"}
              scroll={{ y: 500 }}
              bordered
            />
          </div>
        </div>
      </div>
      {visible && (
        <Modal
          size={MODAL_SIZE.SIZE_1200}
          visibleFooter={false}
          visible={visible}
          title={translate("fileTemplates.fileTemplateInputs.history.title")}
          handleCancel={handleCloseModal}
          titleButtonCancel={translate("general.actions.close")}
          titleButtonApply={translate("general.actions.save")}
          closable={false}
          wrapClassName={"dxg-modal-wrap"}
        >
          <div className="modal-content">
            <div className="m-t--sm">
              <div className="w-100">
                <StandardTable
                  rowKey={"id"}
                  columns={fileTemplateInputColumns}
                  dataSource={fileTemplateInputsInternal}
                  tableSize={"lg"}
                  scroll={{ y: 500 }}
                  isDragable
                  className="table-dxg-file-example"
                  idContainer="table-dxg-file-example"
                />
              </div>
            </div>
          </div>

          <span className={"close-modal"} onClick={handleCloseModal}>
            <Close20 />
          </span>
        </Modal>
      )}
    </Spin>
  );
}

export default MenuReportHistoryPreview;
